/**
 * @fileoverview Clipboard utility for copying text to the system clipboard.
 * @module helpers/copyText
 */

/**
 * Copies text to the system clipboard using a temporary input element.
 *
 * Note: Uses the deprecated execCommand API for broader browser compatibility.
 * Consider using navigator.clipboard.writeText() for modern browsers.
 *
 * @param {string} text - The text to copy to clipboard
 * @returns {void}
 *
 * @example
 * copyText('Hello, World!');
 * // Text is now in clipboard
 */
export const copyText = (text: string) => {
  const inp = document.createElement("input");
  document.body.appendChild(inp);
  inp.value = text;
  inp.select();
  document.execCommand("copy", false);
  inp.remove();
};
